import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useFeatureFlags } from "hooks/useFeatureFlags";

/**
 * Whether the viewer may change a violation's workflow fields: resolution
 * status, assignee, duplicate marks, and field notes. Off for a tenant's own
 * users when Encamp manages its triage; comments and documents stay open.
 * Mirrors the server's `canEditViolationWorkflow` authorizer.
 */
export function useCanEditViolationWorkflow(): boolean {
  const { isStaff } = useCurrentUser();
  const { featureFlags } = useFeatureFlags();
  return isStaff || !featureFlags[FeatureFlagKey.ViolationsStaffManagedTriage];
}
